import React, { useRef, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "react-bootstrap";
import CommonTable from "../../components/tables/CommonTable";
// import api from "../../api";
// import NotyfContext from "../../contexts/NotyfContext";

const SubscribersButton = ({ report, children }) => {
  const [showModal, setShowModal] = useState(false);
  const subscribersTableRef = useRef();
  const columns = [
    {
      Header: "Name",
      accessor: "subscriberCompoundName",
      type: "link",
      link: "/people/edit",
      stateId: "subscriberId",
    },
    {
      Header: "Profile",
      accessor: "subscriberPermissionName",
      type: "link",
      link: "/accessprofiles/edit",
      stateId: "subscriberPermissionId",
    },
    {
      Header: "Email",
      accessor: "subscriberEmail",
      disableSortBy: true,
    },
  ];
  const handleClick = (e) => {
    setShowModal(true);
  };
  const handleClose = (e) => {
    setShowModal(false);
  };
  return (
    <React.Fragment>
      <Button className="mx-1 py-0" variant="secondary" onClick={handleClick}>
        Subscribers
      </Button>
      <Modal size="lg" show={showModal} onHide={handleClose}>
        <ModalHeader closeButton>
          <div className="d-flex justify-content-between w-100 pe-5">
            <ModalTitle>{`Subscribers to '${report.name}' report`}</ModalTitle>
          </div>
        </ModalHeader>
        <ModalBody>
          <CommonTable
            ref={subscribersTableRef}
            apiName={`reports/${report.id}/subscribers`}
            columns={columns}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            // hidden={showAdd}
            onClick={handleClose}
            variant="secondary"
          >
            Close
          </Button>
          {/* <Button hidden={!showAdd} onClick={handleCancel} variant="secondary">
            Cancel
          </Button> */}
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default SubscribersButton;
